export const defaultInputWidth = 130;
export const defaultMaxValue = 100;
export const defaultMinValue = 0;
export const defaultWidth = 250;
export const labelPadding = 26;

export const defaultInputClassConfig: InputClassConfig = {
    base: 'p-2 small-padding rounded border',
    blur: 'border-tertiary-300',
    focus: 'border-secondary-500',
};
